import { useRef, useState } from "react";
import { api } from "../lib/api";
import { Avatar } from "./common";

// Textarea / input with @mention autocomplete.
export function MentionInput({ value, onChange, placeholder, className = "", multiline = true, onEnter, testid }) {
  const ref = useRef();
  const [sug, setSug] = useState([]);
  const [open, setOpen] = useState(false);
  const [range, setRange] = useState(null); // [start, end] of @token
  const tRef = useRef();

  const detect = (text, caret) => {
    const upto = text.slice(0, caret);
    const m = upto.match(/(^|\s)@([A-Za-z0-9_.]{1,30})$/);
    if (!m) { setOpen(false); setSug([]); return; }
    const token = m[2];
    const start = caret - token.length;
    setRange([start, caret]);
    clearTimeout(tRef.current);
    tRef.current = setTimeout(() => {
      api.get(`/mentions/search?q=${encodeURIComponent(token)}`).then(({ data }) => { setSug(data); setOpen(data.length > 0); }).catch(() => setOpen(false));
    }, 200);
  };

  const handleChange = (e) => {
    const text = e.target.value;
    onChange(text);
    detect(text, e.target.selectionStart ?? text.length);
  };

  const pick = (u) => {
    if (!range) return;
    const [s, en] = range;
    const next = value.slice(0, s) + u.username + " " + value.slice(en);
    onChange(next);
    setOpen(false); setSug([]);
    setTimeout(() => ref.current?.focus(), 0);
  };

  const common = {
    ref, value, onChange: handleChange, placeholder,
    "data-testid": testid,
    onKeyDown: (e) => {
      if (open && e.key === "Enter") { e.preventDefault(); if (sug[0]) pick(sug[0]); return; }
      if (!open && e.key === "Enter" && !multiline && onEnter) { onEnter(); }
    },
  };

  return (
    <div className="relative w-full">
      {multiline
        ? <textarea {...common} className={className} />
        : <input {...common} className={className} />}
      {open && (
        <div className="absolute z-50 left-0 right-0 mt-1 surface border border-white/10 rounded-xl overflow-hidden shadow-xl max-h-56 overflow-y-auto" data-testid="mention-dropdown">
          {sug.map((u) => (
            <button key={u.id} type="button" onClick={() => pick(u)} className="w-full flex items-center gap-2 px-3 py-2 hover:bg-white/5 text-left" data-testid={`mention-option-${u.username}`}>
              <Avatar src={u.avatar_url} name={u.display_name} size={28} />
              <div className="min-w-0"><div className="text-sm font-medium truncate">{u.display_name}</div><div className="text-xs text-muted-foreground">@{u.username}</div></div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
